module.exports = __webpack_public_path__ + "static/viral-ebd4cc33108cfa077e544111e5fe55c6.png";